import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-d5441efe")
const _hoisted_1 = { class: "_main account" }
const _hoisted_2 = { class: "_header" }
const _hoisted_3 = { class: "_headerBack" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " Account ", -1)
const _hoisted_5 = {
  key: 0,
  class: "_loadPrompt"
}
const _hoisted_6 = {
  key: 1,
  class: "user"
}
const _hoisted_7 = { class: "meta" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Hi there!")
const _hoisted_9 = {
  key: 0,
  class: "_card card"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h4", null, " Account information ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "_a" }, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "_dev" }, "DEV", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" You are a developer ")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 1,
  class: "_card card"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h4", null, " Account successfully deleted ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, " Thank you for being part of our community. You will be surely missed! ", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 2,
  class: "_card card"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h4", null, " Account deletion error ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Sorry, there was an error when attempting to delete your account. Please try again. If the problem persists, "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:help.gochase.me@gmail.com" }, "email us"),
  /*#__PURE__*/_createTextVNode(" and we'll delete your account manually. ")
], -1)
const _hoisted_24 = { style: {"opacity":"0.75"} }
const _hoisted_25 = {
  key: 3,
  class: "_card card"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h3", null, " Login to get started! ", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "_a" }, null, -1)
const _hoisted_29 = { style: {"opacity":"0.75"} }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" By logging in, you agree to our ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("terms of service")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("privacy policy")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(", and agree to have cookies set on your device in accordance with our ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("cookie policy")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_37 = {
  key: 4,
  class: "_card card"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h4", null, " Account management ", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "_a" }, null, -1)
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "_warning" }, "Are you absolutely sure?", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "_a" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Deleting your account will remove all of your personal data - this includes your game purchases and history. This data cannot be recovered. ")
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "_card" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h4", null, "Your privacy is important to us", -1)
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" As outlined in our ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("privacy policy")
const _hoisted_50 = /*#__PURE__*/_createTextVNode(", you may ask for your personal data to be deleted at any time. Please note, this will also remove any purchases affiliated with the account. ")
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" You are currently logged out. Once logged in however, you can select to delete your account here or you may email us so we can do it for you. ")
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" To achieve this, either ")
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" here, or ")
const _hoisted_54 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:help.gochase.me@gmail.com" }, "email us", -1)
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" so we can do it for you. ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_LoadSpinner = _resolveComponent("LoadSpinner")!
  const _component_LoginButton = _resolveComponent("LoginButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_IconButton, {
          icon: "back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({path:'/app'}))),
          white: true
        })
      ]),
      _hoisted_4
    ]),
    (_ctx.loadingUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_LoadSpinner, { text: "Loading account" })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.$store.state.Auth.user.avatar)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass({icon:true, [_ctx.$store.state.Auth.user.avatar]:true, _img:true})
                }, null, 2))
              : (_ctx.$store.state.Auth.user)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass({icon:true, _img:true}),
                    style: _normalizeStyle(`background-image: url(${_ctx.$store.state.Auth.user.picture})`)
                  }, null, 4))
                : _createCommentVNode("", true),
            _createElementVNode("h2", null, [
              (_ctx.$store.state.Auth.user.name)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Hi, " + _toDisplayString(_ctx.$store.state.Auth.user.name), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_8
                  ], 64))
            ])
          ]),
          (!_ctx.$store.state.Auth.user.guest && !_ctx.$store.state.Auth.user.signedOut)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("p", null, " Email: " + _toDisplayString(_ctx.$store.state.Auth.user.email), 1),
                _hoisted_11,
                (_ctx.$store.state.Auth.user.developer > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _hoisted_15))
                  : (_openBlock(), _createElementBlock("p", _hoisted_16, "Not a developer"))
              ]))
            : _createCommentVNode("", true),
          (_ctx.deleteSuccess)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
            : _createCommentVNode("", true),
          (_ctx.deleteError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _hoisted_22,
                _hoisted_23,
                _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.deleteError), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.$store.state.Auth.user.signedOut || _ctx.$store.state.Auth.user.guest)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _hoisted_26,
                _hoisted_27,
                _createVNode(_component_LoginButton, { text: "Facebook login" }),
                _hoisted_28,
                _createElementVNode("p", _hoisted_29, [
                  _hoisted_30,
                  _createVNode(_component_router_link, { to: "/policy/terms" }, {
                    default: _withCtx(() => [
                      _hoisted_31
                    ]),
                    _: 1
                  }),
                  _hoisted_32,
                  _createVNode(_component_router_link, { to: "/policy/privacy" }, {
                    default: _withCtx(() => [
                      _hoisted_33
                    ]),
                    _: 1
                  }),
                  _hoisted_34,
                  _createVNode(_component_router_link, { to: "/policy/cookie" }, {
                    default: _withCtx(() => [
                      _hoisted_35
                    ]),
                    _: 1
                  }),
                  _hoisted_36
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _hoisted_38,
                _hoisted_39,
                (_ctx.deleteRequested)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_40, [
                      _hoisted_41,
                      _hoisted_42,
                      _hoisted_43,
                      _hoisted_44,
                      _createVNode(_component_IconButton, {
                        text: _ctx.deleting?'Deleting':'Yes, delete account',
                        icon: _ctx.deleting?'loader_spinner':'',
                        autoplay: true,
                        loop: true,
                        hex: "#FFFFFF",
                        onClick: _ctx.confirmDelete,
                        colored: true
                      }, null, 8, ["text", "icon", "onClick"])
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_45, [
                      _createVNode(_component_IconButton, {
                        text: "Delete account",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteRequested = true)),
                        colored: true
                      })
                    ]))
              ])),
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _createElementVNode("p", null, [
              _hoisted_48,
              _createVNode(_component_router_link, { to: "/policy/privacy" }, {
                default: _withCtx(() => [
                  _hoisted_49
                ]),
                _: 1
              }),
              _hoisted_50,
              (_ctx.$store.state.Auth.user.signedOut || _ctx.$store.state.Auth.user.guest)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_51
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_52,
                    _createElementVNode("a", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteRequested = true))
                    }, "delete your account"),
                    _hoisted_53,
                    _hoisted_54,
                    _hoisted_55
                  ], 64))
            ])
          ])
        ]))
  ]))
}